import axios from "axios";
import React, { Fragment, useContext, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import {
  Card,
  CardBody,
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import {
  WorkExpEditApi,
  WorkExpSaveApi,
} from "../../../../api/index";
import { toastMessage } from "../../../../redux/utils/tuteairCommon";
import { authHeader } from "../../../../Services/AuthVerify";
import "../../../../style/custom-css/PersonalInfo.css";
import MemberInformationContext from "../../../../_helper/MemberInformation";

const TutorExperienceModal = (props) => {
  const [isOpen, setIsOpen] = useState(props.isOpen);
  const [position, setPosition] = useState("");
  const [organization, setOrganization] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [running, setIsRunning] = useState();
  const [isShow, setIsShow] = useState(true);

  const [endDate, setEndDate] = useState(new Date());

  const [aboutWorkExp, setAboutWorkExp] = useState("");
  const [loading, setLoading] = useState(false);

  const {
    getMemberInformation
  } = useContext(MemberInformationContext)

  useEffect(() => {
    setPosition(props.expSingleData.position);
    setOrganization(props.expSingleData.organization);
    setStartDate(new Date(props.expSingleData.startDate));
    setIsRunning(props.expSingleData.running);
    setEndDate(new Date(props.expSingleData.endDate));
    setAboutWorkExp(props.expSingleData.aboutWorkExp);
  }, [props.expSingleData]);

  const handleStartDateChange = (date) => {
    setStartDate(new Date(date));
  };
  const handleEndDateChange = (date) => {
    setEndDate(new Date(date));
  };

  const checkboxHandler = async (isChk) => {
    setIsRunning(isChk);
    if (isChk === true) setEndDate("");
    else setEndDate(new Date());
  };

  const validatedField = () => {
    if (!position || !organization || !startDate) {
      toastMessage("Fillup required field!", "warn");
      return false;
    } else if (!isNaN(position)) {
      toastMessage("Enter valid position name!", "warn");
      return false;
    } else if (!isNaN(organization)) {
      toastMessage("Enter valid organization name!", "warn");
      return false;
    } else if (!isNaN(aboutWorkExp)) {
      toastMessage("Enter valid work experience!", "warn");
      return false;
    } else {
      return true;
    }
  };

  const addNewExperience = async (e) => {
    e.preventDefault();

    if (validatedField()) {
      setLoading(true);
      if (window.confirm("Are you sure to save this information?")) {
        var req = {
          position,
          organization,
          startDate,
          endDate,
          running,
          aboutWorkExp,
        };

        const response = await axios.post(WorkExpSaveApi, req, {
          headers: {
            Authorization: authHeader(),
          },
        });

        if (response.status === 201) {
          if (response.data && response.data) {
            toast.success("Experience Info Added successully", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
            });
            props.toggler();
            getMemberInformation();
          } else {
            toast.warn("Failed to add", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
            });
          }
          setLoading(false);
        } else {
          setLoading(false);
          toast.warn("something went wrong", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        }
      }
      else {
        setLoading(false);
      }
    }

  };

  const handleUpdateExperience = async (e) => {
    e.preventDefault();
    var req = JSON.stringify({
      position,
      organization,
      startDate,
      endDate,
      running,
      aboutWorkExp,
    });

    if (validatedField()) {
      setLoading(true);
      if (window.confirm("Are you sure to update this information?")) {
        const res = await axios.put(
          WorkExpEditApi + "/" + props.expSingleData.id,
          req,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: authHeader(),
            },
          }
        );

        if (res.status === 201) {
          if (res.data && res.data) {
            const msg = "Expereince Updated Succefully";
            toast.success(msg, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
            });
            props.toggler();
            getMemberInformation();
          } else {
            toast.warn("Failed to add", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
            });
          }
          setLoading(false);
        } else {
          setLoading(false);
          toast.warn("something went wrong", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        }
      }
      else {
        setLoading(false);
      }
    }
  };

  return (
    <Fragment>
      <Modal
        isOpen={props.isOpen}
        toggle={props.toggler}
        centered
        className="modal-lg"
        backdrop={"static"}
      >
        <ModalHeader toggle={props.toggler}>{props.title}</ModalHeader>
        <ModalBody className={"pb-0 " + props.bodyClass}>
          <Col sm="12" xl="12 box-col-12">
            <Card className="mb-0">
              <CardBody className="megaoptions-border-space-sm">
                <Row>
                  <Col sm="12" xl="12">
                    <div className="row mb-2">
                      <Label
                        className="col-sm-2 col-form-label asterisk"
                        htmlFor=""
                      >
                        Position
                      </Label>
                      <Col sm="10">
                        <Input
                          className="form-control"
                          type="text"
                          required
                          placeholder="Enter Position"
                          value={position}
                          onChange={(e) => setPosition(e.target.value)}
                        />
                      </Col>
                    </div>
                    <div className="row mb-2">
                      <Label
                        className="col-sm-2 col-form-label asterisk"
                        htmlFor=""
                      >
                        Organization
                      </Label>
                      <Col sm="10">
                        <Input
                          className="form-control"
                          type="text"
                          placeholder="Enter Organization"
                          value={organization}
                          onChange={(e) => setOrganization(e.target.value)}
                        />
                      </Col>
                    </div>
                    <div className="row mb-2">
                      <Label
                        className="col-sm-2 col-form-label asterisk"
                        htmlFor="inputEmail3"
                      >
                        Start Date
                      </Label>
                      <Col sm="4">
                        <DatePicker
                          className="form-control digits"
                          selected={startDate}
                          maxDate={endDate}
                          onChange={handleStartDateChange}
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          dateFormat="dd MMMM yyyy"
                        />
                      </Col>
                      {endDate && !running && (
                        <Label
                          className="col-sm-2 col-form-label asterisk"
                          htmlFor="inputEmail3"
                        >
                          End Date
                        </Label>
                      )}
                      <Col sm="4">
                        {endDate && !running && (
                          <DatePicker
                            className="form-control digits"
                            selected={endDate}
                            minDate={startDate}
                            maxDate={new Date()}
                            onChange={handleEndDateChange}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            dateFormat="dd MMMM yyyy"
                          />
                        )}
                      </Col>
                    </div>
                    <div className="row mb-2">
                      <Label
                        className="col-sm-2 col-form-label"
                        htmlFor="inputEmail3"
                      >
                        Is Running
                      </Label>
                      <Col sm="10">
                        <Input
                          id=""
                          type="checkbox"
                          checked={running === true}
                          onChange={(event) => {
                            checkboxHandler(event.target.checked);
                          }}
                        />
                      </Col>
                    </div>
                    <div className="row mb-2">
                      <Label
                        className="col-sm-2 col-form-label"
                        htmlFor="inputEmail3"
                      >
                        About Work Experience
                      </Label>
                      <Col sm="10">
                        <Input
                          type="textarea"
                          className="form-control"
                          rows="3"
                          value={aboutWorkExp}
                          onChange={(e) => setAboutWorkExp(e.target.value)}
                        />
                      </Col>
                    </div>
                  </Col>
                  <Col sm="12" xl="12">
                    <div className="row mb-2"></div>
                    <div className="row mb-2"></div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </ModalBody>
        <ModalFooter>
          <Btn attrBtn={{ color: "warning", onClick: props.toggler }}>
            Close
          </Btn>
          <Btn
            attrBtn={{
              color: "success",
              disabled: loading ? loading : loading,
              onClick: (e) =>
                props.edit ? handleUpdateExperience(e) : addNewExperience(e),
            }}
          >
            {loading ? "LOADING..." : "Save changes"}
          </Btn>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default TutorExperienceModal;
